let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dd1nQ")).then(() => parcelRequire('1uyZT'));